export const isUserVisibleTrigger = (t: {name: string}) => {
  return !t.name.startsWith('[WANDB_INTERNAL]');
};
